import React, { useEffect, useState } from "react";
import { getImageUrl, teamLeagueInfoUrl } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";
import NextImage from "../common/NextImage";
import NoDataFound from "../common/NoDataFound";

const IceHockeyMatchTable = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
  sport = "icehockey",
  websiteBaseUrl,
  dataPath,
}) => {
  const [clientData, setClientData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("leaguestandings");
    }
  }, [loadCSS]);

  const rawData = dataClient ? clientData : data;
  console.log(rawData)
  const tableData = rawData || rawData;

  if (!tableData?.length) {
    return <NoDataFound />;
  }

  return (
    <div className="global_table standing_table rugby">
      {title && <h1>{title}</h1>}
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>
              <span>Teams</span>
            </th>
            <th>P</th>
            <th>W</th>
            <th>L</th>
            <th>D</th>
            <th>GF</th>
            <th>GA</th>
            <th>PTS</th>
            <th>FORM</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((t, index) => (
            <tr key={index}>
              <td>{t?.pc || t?.plc}</td>
              <td>
                <a
                  href={teamLeagueInfoUrl({
                    dataClient,
                    websiteBaseUrl,
                    dataPath,
                    category: "team",
                    sport,
                    name: t?.nm || t?.team?.nm || t?.tnam,
                    id: t?.team_id || t?.team?.id || t?.tid,
                  })}
                  className="team_name"
                >
                  <div className="bolar_team">
                    <div className="ico_flag">
                      <NextImage
                        src={getImageUrl("", "", sport, t?.team_id || t?.team?.id || t?.tid)}
                        width={22}
                        height={22}
                      />
                    </div>
                    <span className="name">{t?.nm || t?.team?.nm || t?.tnam}</span>
                  </div>
                </a>
              </td>
              <td>{t?.pl || t?.ply}</td>
              <td>{t?.wo || t?.wins}</td>
              <td>{t?.lo || t?.los}</td>
              <td>{t?.dr || t?.dra}</td>
              <td>{t?.gf || t?.gol_f}</td>
              <td>{t?.ga || t?.gol_ag}</td>
              <td>{t?.pts}</td>
              <td>
                <ul className="prev_match_status">
                  {(t?.lfm || t?.form?.split(""))?.map((w, idx) => (
                    <li
                      key={idx}
                      className={`${w === "W" ? "win" : w === "L" ? "loss" : "draw"}`}
                    >
                      {w}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IceHockeyMatchTable;
